import axios, { AxiosResponse } from 'axios';


export default class PolicyService
{
	public getPolicyId(assessmentId: string, version: number, questionId: string, policyNumber: string, postcode?: string, dateOfBirth?: string, emailAddress?: string): Promise<number>
	{
		let url = `${window.__appSettings.apiEndpoints.policyApi}/${assessmentId}/${version}/${questionId}?policyNumber=${encodeURIComponent(policyNumber)}`;

		if(postcode)
			url += `&postCode=${encodeURIComponent(postcode)}`;

		if(dateOfBirth)
			url += `&dateOfBirth=${encodeURIComponent(dateOfBirth)}`;

		if(emailAddress)
			url += `&emailAddress=${encodeURIComponent(emailAddress)}`;

		return axios.get<number>(url)
			.then(response =>
			{
				this.checkResponse(url, response);
				return response.data;
			});
	}

	private checkResponse<T>(url: string, response: AxiosResponse<T>): boolean
	{
		if (response.status >= 200 && response.status <= 299)
		{
			console.info(`Call to ${url} was successful`);
			return true;
		}

		throw new Error(`Failed to call ${url} (Status: ${response.status})`);
	}
}
